import _ from 'lodash';
import template from './quantitySelector.html';
import './quantitySelector.scss';

class QuantitySelectorComponent {
    /*@ngInject*/ 
    constructor(constants, $timeout, catalogService) {
        this.constants = constants;
        this.$timeout = $timeout;
        this.catalogService = catalogService;
    }

    $onInit() {
        this.quantity = this._getPositiveInt(this.quantity, 1);

        if (_.isNil(this.min))
            this.min = 0;

        if (_.isNil(this.max)) {
            this.catalogService.getProduct(this.id).then((productResponse) => {
                this.max = productResponse.data.length > 0 ? 
                    this._getPositiveInt(productResponse.data[0].maxQuantity, this.constants.products.maxPerCart):
                    this._getPositiveInt(this.max, this.constants.products.maxPerCart);

                this.options = _.range(this.min, (this.max + 1));
            });
        } else {
            this.max = this._getPositiveInt(this.max, this.constants.products.maxPerCart);
            this.options = _.range(this.min, (this.max + 1));
        }
    }

    onSelected() {
        if (_.isFunction(this.onUpdateCart))
            this.$timeout(() => {
                this.onUpdateCart();
            }, 0);
    }

    _getPositiveInt(value, defaultValue) {
        let result = !_.isNil(value)
            ? _.toNumber(value)
            : -1;

        if (result <= 0) {
            result = defaultValue;
        }

        return this._adjustMaxQuantity(result);
    }

    _adjustMaxQuantity(maxRange) {
        let quantityRemainder = this.quantity % 10;

        return this.quantity >  maxRange ?
            this.quantity + (quantityRemainder === 0 ? 0 : 10 - quantityRemainder) :
            maxRange;
    }
}

export default {
    template: template,
    bindings: {
        productId: '<',
        min: '<',
        max: '<',
        quantity: '=',
        onUpdateCart: '&',
        id: '<',
        isBuyable: '<'
    },
    controller: QuantitySelectorComponent
};